var exports = {
  "kL": "x936d19a0--392505--container",
  "nf": "x936d19a0--392505--link",
  "Hw": "x936d19a0--392505--mobile",
};

module.exports = exports;
